export default __webpack_public_path__ + "static/media/ritchie torres.e2311bc3.jpg";